import { Pagination } from '@shared/interfaces';
import { ApplicationSummaryFromApi } from '../interfaces/applications-summary.interface';
import { PaginatedResponse } from '@app/core/models/paginated-response.model';
import { GetApplicationsSummariesParams } from '../interfaces/get-application-summaries-params.interface';

export const DEFAULT_PAGINATION: Pagination = {
  limit: 10,
  offset: 0,
};

export const RESOURCE_INITIAL_VALUE: PaginatedResponse<ApplicationSummaryFromApi> =
  {
    count: 0,
    next: null,
    previous: null,
    results: [],
  };

export const RESOURCE_FILTER_INITIAL_VALUES: GetApplicationsSummariesParams = {
  ...DEFAULT_PAGINATION,
  ordering: null,
  search: null,
};
